import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "container-default !px-3 !lg:px-0" }
const _hoisted_3 = { class: "relative w-full max-w-4xl mx-auto rounded-xl overflow-hidden text-center" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "relative bg-black/80 px-3 py-16 lg:px-12 flex flex-col space-y-6" }
const _hoisted_6 = {
  key: 1,
  class: "relative px-3 lg:px-12 py-0 flex flex-col space-y-6"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextCenteredSection',
  props: ["id", "src", "alt"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _directive_parallax = _resolveDirective("parallax")!
  const _directive_animate = _resolveDirective("animate")!

  return (_openBlock(), _createElementBlock("section", { id: __props.id }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!!__props.src)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _withDirectives(_createElementVNode("img", {
                class: "absolute top-0 left-0 object-cover w-full h-full",
                src: __props.src,
                alt: __props.alt || __props.id
              }, null, 8, _hoisted_4), [
                [_directive_parallax, {
                            from: { yPercent: 25, scale: 1.5 },
                            to: { yPercent: -25, scale: 1.5 },
                        }]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "default")
              ])), [
                [
                  _directive_animate,
                  void 0,
                  void 0,
                  { stagger: true }
                ]
              ])
            ], 64))
          : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "default")
            ])), [
              [
                _directive_animate,
                void 0,
                void 0,
                { stagger: true }
              ]
            ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})